import TraceKit from "tracekit"
export default {
  install: function(app) {
    var _oldOnError = app.config.errorHandler;
    app.config.errorHandler = function(error, vm, info){
      // Tracekit is rethrowing exception
      try{
        TraceKit.report(error);
      }
      catch(error) {

      }
      if (typeof _oldOnError === 'function') {
        _oldOnError.call(this, error, vm, info);
      }
      console.error(error);
    }
  }
}